import { AssetPriceMarquee } from '@/components/Layouts/AssetPriceMarquee'
import LatencyIndicator from '@/components/Layouts/LatencyIndicator'
import { WithTooltip } from '@/components/orders/WithTooltip'
import { publicConfig } from '@/config/publicConfig'
import { getAppDisplayName } from '@/utils/appBranding'

interface FooterProps {
  isApiAvailable: boolean
}

const commitSha = publicConfig.vercel.gitCommitSha

const Footer = ({ isApiAvailable }: FooterProps) => {
  return (
    <div
      id="dora-footer"
      // Adjusted height and layout for marquee
      className="h-auto min-h-8 pb-[env(safe-area-inset-bottom)] md:min-h-0 md:pb-0 flex flex-col w-full z-50 fixed bottom-0 bg-panel border border-x-0 border-b-0 border-panel-border"
    >
      {/* Wrapper for bottom row content (Copyright, Version, API Status) */}
      <div className="flex w-full justify-between px-2 items-center">
        {/* Copyright Div */}
        <div className="hidden md:block z-10 bg-panel left-0 dark:text-white-dark text-center ltr:sm:text-left rtl:sm:text-right whitespace-nowrap">
          © {new Date().getFullYear()}. {getAppDisplayName()}.
        </div>
        {/* Version Div (Conditional) */}
        {commitSha && (
          <div className={'hidden md:flex flex-row gap-1 items-center'}>
            <div className={'text-white-dark'}>Version:</div>
            <a
              target={'_blank'}
              href={`https://github.com/dora-network/frontend-bonds/commit/${commitSha}`}
              className={'text-primary'}
              rel="noopener noreferrer"
            >
              <div>{commitSha.substring(0, 7)}</div>
            </a>
          </div>
        )}
        <div className="hidden md:flex min-w-0 flex-1">
          <AssetPriceMarquee />
        </div>
        {/* Latency Indicator */}
        <WithTooltip
          tooltipString="Connection latency to DORA backend. Lower is better for execution timing."
          noTextDecoration={true}
        >
          <LatencyIndicator />
        </WithTooltip>
        {/* API Status Div */}
        <div className="ml-2 items-center flex gap-2 z-10 bg-panel right-0 dark:text-white-dark text-center ltr:sm:text-left rtl:sm:text-right">
          <div
            style={{
              width: '0.4rem',
              height: '0.4rem',
              borderRadius: '50%',
              backgroundColor: isApiAvailable ? 'green' : 'red',
            }}
          />
          <h2>API </h2>
        </div>{' '}
        {/* Close wrapper div */}
      </div>
    </div>
  )
}

export default Footer
